export default __webpack_public_path__ + "static/media/louvre_right_side.81dcfaad.jpg";